/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { AccountRoleEnum } from '@smmof/enum';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboards',
    title: 'Добро пожаловать',
    subtitle: '',
    type: 'basic',
    icon: 'favorite',
    link: '/dashboard/onboarding',
  },
  {
    id: 'platform-catalog',
    title: 'Каталог каналов',
    subtitle: '',
    type: 'basic',
    icon: 'heroicons_outline:search-circle',
    link: '/advertiser/platforms',
  },
  {
    id: 'ad-publications',
    title: 'Рекламные публикации',
    subtitle: '',
    type: 'collapsable',
    icon: 'ads_click',
    children: [
      {
        id: 'ad-publications.create',
        title: 'Создать заказ',
        type: 'basic',
        icon: 'heroicons_outline:plus-circle',
        link: '/advertiser/ad-order/create',
      },
      {
        id: 'ad-publications.list',
        title: 'Список заказов',
        type: 'basic',
        icon: 'heroicons_outline:presentation-chart-line',
        link: '/advertiser/ad-order/all',
      },
    ],
  },
  {
    id: 'collections',
    title: 'Подборки',
    role: AccountRoleEnum.ADMIN,
    subtitle: '',
    type: 'collapsable',
    icon: 'heroicons_outline:share',
    children: [
      {
        id: 'collections.create',
        title: 'Создать подборку',
        type: 'basic',
        icon: 'heroicons_outline:plus-circle',
        link: '/collections/create',
      },
      {
        id: 'collections.my',
        title: 'Мои подборки',
        type: 'basic',
        icon: 'heroicons_outline:collection',
        link: '/collections/my',
      },
      {
        id: 'collections.invitations',
        title: 'Приглашения',
        type: 'basic',
        icon: 'heroicons_outline:mail-open',
        link: '/collections/invitations',
      },
    ],
  },
  {
    id: 'performer',
    title: 'Блогер',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [
      {
        id: 'performer.project',
        title: 'Мои площадки',
        type: 'basic',
        icon: 'heroicons_outline:view-list',
        link: '/performer/platforms',
      },
      // {
      //   id: 'performer.add-platform',
      //   title: 'Добавить площадку',
      //   type: 'basic',
      //   icon: 'playlist_add',
      //   link: '/performer/append',
      // },
      {
        id: 'dashboards.project',
        title: 'Модерация заявок',
        type: 'basic',
        icon: 'heroicons_outline:fire',
        link: '/performer/ad-order-awaiting',
        // badge: {
        //   title: '1',
        //   classes: 'px-2.5 bg-yellow-300 text-black rounded-full',
        // },
      },
      {
        id: 'dashboards.project',
        title: 'Заказы от рекламодателей',
        type: 'basic',
        icon: 'heroicons_outline:collection',
        link: '/performer/ad-order',
      },
    ],
  },
  {
    id: 'account',
    title: 'Личный кабинет',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [
      {
        id: 'account.ecommerce',
        title: 'Финансы',
        type: 'collapsable',
        icon: 'heroicons_outline:cash',
        // link: '/account/finance',
        children: [
          {
            id: 'account.ecommerce.inventory',
            title: 'Детализация',
            type: 'basic',
            link: '/account/finance/details',
          },
          {
            id: 'profile.ecommerce.inventory',
            title: 'Пополнение баланса',
            type: 'basic',
            link: '/account/finance/deposit',
          },
          {
            id: 'profile.ecommerce.inventory',
            title: 'Вывод средств',
            type: 'basic',
            link: '/account/finance/withdraw',
          },
        ],
      },
      // {
      //   id: 'profile.mailbox',
      //   title: 'Сообщения',
      //   type: 'basic',
      //   icon: 'heroicons_outline:mail',
      //   link: '/apps/mailbox',
      //   badge: {
      //     title: '27',
      //     classes: 'px-2 bg-pink-600 text-white rounded-full',
      //   },
      // },
      {
        id: 'profile.notes',
        title: 'Настройки',
        type: 'basic',
        icon: 'heroicons_outline:cog',
        link: '/account/settings',
      },
      {
        id: 'profile.scrumboard',
        title: 'Партнёрская программа',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/account/affiliate-program',
      },
      {
        id: 'profile.scrumboard',
        title: 'Программа лояльности',
        type: 'basic',
        icon: 'heroicons_outline:trending-up',
        link: '/account/loyalty-program',
      },
      {
        id: 'divider-1',
        type: 'divider',
      },
      {
        id: 'profile.chat',
        title: 'Запрос в поддержку',
        type: 'basic',
        icon: 'heroicons_outline:chat-alt',
        link: '/account/support',
      },
      {
        id: 'profile.help-center',
        title: 'Помощь и правила',
        type: 'collapsable',
        icon: 'heroicons_outline:support',
        link: '/apps/help-center',
        children: [
          {
            id: 'apps.help-center.home',
            title: 'Правила сервиса',
            type: 'basic',
            link: '/regulations',
            exactMatch: true,
          },
        ],
      },
    ],
  },
  {
    id: 'admin',
    role: AccountRoleEnum.ADMIN,
    title: 'Администрирование',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [
      {
        id: 'admin.moderation',
        title: 'Модерация площадок',
        type: 'basic',
        icon: 'heroicons_outline:exclamation-circle',
        link: '/admin/moderation',
      },
      {
        id: 'admin.news',
        title: 'Новости',
        type: 'collapsable',
        icon: 'heroicons_outline:newspaper',
        children: [
          {
            id: 'admin.news.posts',
            title: 'Управление новостями',
            type: 'basic',
            link: '/admin/news',
          },
          {
            id: 'admin.news.comments',
            title: 'Модерация комментариев',
            type: 'basic',
            link: '/admin/news/comments',
          },
        ],
      },
      {
        id: 'admin.payments',
        title: 'Выплаты',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/admin/payments',
      },
      {
        id: 'admin.newsletter',
        title: 'Рассылка',
        type: 'basic',
        icon: 'heroicons_outline:mail',
        link: '/admin/newsletter',
      },
      {
        id: 'admin.promo-codes',
        title: 'Промокоды',
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link: '/admin/promo-codes',
      },
    ],
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];

export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];

export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboards',
    title: 'Dashboards',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'apps',
    title: 'Apps',
    type: 'group',
    icon: 'heroicons_outline:qrcode',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'pages',
    title: 'Pages',
    type: 'group',
    icon: 'heroicons_outline:document-duplicate',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'user-interface',
    title: 'UI',
    type: 'group',
    icon: 'heroicons_outline:collection',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'navigation-features',
    title: 'Misc',
    type: 'group',
    icon: 'heroicons_outline:menu',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
